<template>
  <s-section
    :title="title"
    itemscope
    itemtype="https://schema.org/FAQPage"
  >
    <div class="row">
      <div class="col-xl-9 ml-auto">
        <s-accordion v-if="faq.items">
          <s-accordion-item
            v-for="item in faq.items"
            :key="item.id"
            :title="item.question"
            :has-micro-data="true"
            itemscope
            itemprop="mainEntity"
            itemtype="https://schema.org/Question"
          >
            <div
              class="text-content"
              itemprop="text"
              v-html="item.answer"
            ></div>
          </s-accordion-item>
        </s-accordion>
      </div>
    </div>
  </s-section>
</template>

<script>
export default {
  name: 'Faq',
  props: {
    faq: {
      type: Object,
      default() {
        return {}
      }
    },
    title: {
      type: String,
      default: 'FAQ'
    }
  }
}
</script>